
const ENModalFormulaAssistant = {
	"Assistente de Fórmulas": "Formula Assistant",
	"Como funciona os períodos": "How periods work",
	"Utilize períodos anteriores ou posteriores para buscar valor do campo de outros períodos": 
	"Use previous or following periods to search value of other fields",
	"Por exemplo, período anterior - 1, quando estiver no período mensal Fevereiro, irá buscar o valor correspondente ao período de Janeiro" : 
	"For example, previous period - 1, when you are in the monthly February period, it will search the value corresponding to the January period",
	"Abrir assistente de fórmulas": "Open formula assistant",
	"CodigoCampo": "FieldCode",
	"Fórmula": "Formula",
	"Fórmula em texto": "Formula in text",
	"Apenas metas": "Only targets",
	"Apenas campos": "Only fields"
};


export default ENModalFormulaAssistant;
